"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_FORMATTED_BET = exports.UPDATE_BET_FEATURE_SET = exports.UPDATE_BET = exports.SET_DEFAULT_BET = exports.REQUEST_BET_FEATURE_SET = exports.DENOM_TOGGLE = exports.DENOM_PLUS = exports.DENOM_MINUS = exports.DENOM = exports.COINS_PLUS = exports.COINS_MINUS = exports.COINS = exports.BET_CHANGE_ENABLE = exports.BET_CHANGE_DISABLE = void 0;
var UPDATE_FORMATTED_BET = exports.UPDATE_FORMATTED_BET = "UPDATE_FORMATTED_BET";
var UPDATE_BET = exports.UPDATE_BET = "UPDATE_BET";
var SET_DEFAULT_BET = exports.SET_DEFAULT_BET = "SET_DEFAULT_BET";
var BET_CHANGE_DISABLE = exports.BET_CHANGE_DISABLE = "BET_CHANGE_DISABLE";
var BET_CHANGE_ENABLE = exports.BET_CHANGE_ENABLE = "BET_CHANGE_ENABLE";
var COINS_PLUS = exports.COINS_PLUS = "COINS_PLUS";
var COINS_MINUS = exports.COINS_MINUS = "COINS_MINUS";
var DENOM_MINUS = exports.DENOM_MINUS = "DENOM_MINUS";
var DENOM_PLUS = exports.DENOM_PLUS = "DENOM_PLUS";
var DENOM_TOGGLE = exports.DENOM_TOGGLE = "DENOM_TOGGLE";
var DENOM = exports.DENOM = "DENOM";
var COINS = exports.COINS = "COINS";
var UPDATE_BET_FEATURE_SET = exports.UPDATE_BET_FEATURE_SET = "UPDATE_BET_FEATURE_SET";

/** will validate that you are allowed to update the feature set. */
var REQUEST_BET_FEATURE_SET = exports.REQUEST_BET_FEATURE_SET = "REQUEST_BET_FEATURE_SET";

//Actions
//# sourceMappingURL=types.js.map